module.exports = __webpack_public_path__ + "static/img/cup.705f9054.png";